import footer from './footer'
import header from './header'
import error from './error'
import signUp from './signUp'
import phoneRequest from './phoneRequest'
import form from './form'
import phoneValidate from './phoneValidate'
import skolkovo from './skolkovo'
import noticeTrialHasExpired from './noticeTrialHasExpired'

export default {
  footer,
  header,
  error,
  signUp,
  phoneRequest,
  form,
  phoneValidate,
  skolkovo,
  noticeTrialHasExpired
}
